import React from 'react';

export function useRequestMediaPermissions(
  requestedMedia: MediaStreamConstraints | undefined
) {
  const [mediaStream, setMediaStream] = React.useState<MediaStream | null>(
    null
  );
  const [requestCounter, setRequestCounter] = React.useState(0);
  const requestMediaPermissions = React.useCallback(
    () => setRequestCounter(Math.random()),
    []
  );

  React.useEffect(() => {
    if (!requestCounter) return;
    async function enableVideoStream() {
      try {
        const stream =
          await navigator.mediaDevices.getUserMedia(requestedMedia);
        setMediaStream(stream);
      } catch {
        // Handle the error
      }
    }

    if (!mediaStream) {
      enableVideoStream();
    } else {
      return function cleanup() {
        mediaStream.getTracks().forEach((track) => {
          track.stop();
        });
      };
    }
  }, [mediaStream, requestCounter, requestedMedia]);

  return [mediaStream, requestMediaPermissions] as const;
}
